<template>
  <div id="app">
    <div class="sidebar" :style="l_routerViewWidth" v-if="l_sidebarAvailable">
      <router-view v-slot="{ Component }">
        <transition>
          <component :is="Component" />
        </transition>
      </router-view>
      <!-- Small Size Side Bar - Using standard Bootstrap classes -->
      <div class="position-fixed bg-light text-dark d-flex flex-column h-100 text-center"
           v-show="!l_sidebarExpanding"
           style="width: 80px; left: 0; top: 0; z-index: 1050;">

        <div class="mt-3">
          <img src="./assets/logo/アプリアイコン_黄グラデ_R1.png" class="img-fluid mb-3" style="height:50px">
        </div>

        <div class="flex-grow-1" style="overflow-y: auto; overflow-x: hidden;">
          <button
            v-for="data in l_sidebarMenuData"
            :key="l_sidebarMenuData.indexOf(data)"
            class="btn w-100 d-flex align-items-center justify-content-center mb-1"
            :class="isLinkActive(data.path) ? 'btn-primary text-light' : 'btn-light'"
            @click="$router.push(data.path)"
            :disabled="(data.icon=='map' && isClosing==true) ? true : false"
            style="height:60px;"
          >
            <i class="ml-2 pl-1 align-middle bi" :class="`bi-${data.icon}`"></i>
          </button>
        </div>

        <div class="mt-auto">
          <div class="m-3">
            <b-card no-body>
              <img src="./assets/logo/kaminoyama.jpg" class="img-fluid w-100">
            </b-card>
          </div>
          <div class="mb-3">
            <b-button size="sm" @click="l_expandSideBar">
              <i class="bi bi-chevron-bar-right fs-3"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Big Size Side Bar - Using standard Bootstrap classes -->
      <div class="position-fixed bg-light text-dark h-100"
           v-show="l_sidebarExpanding"
           style="width: 280px; left: 0; top: 0; z-index: 1050;">

        <div class="p-3 h-100 d-flex flex-column">
          <div class="text-center mb-3">
            <img src="./assets/logo/アプリアイコン_黄グラデ_R1_収集しマース.png" class="img-fluid mb-3" style="height:50px">
          </div>

          <div class="flex-grow-1" style="overflow-y: auto; overflow-x: hidden;">
            <button
              v-for="data in l_sidebarMenuData"
              :key="l_sidebarMenuData.indexOf(data)"
              class="btn w-100 d-flex align-items-center mb-2"
              :class="l_currentPath == data.path ? 'btn-primary text-light' : 'btn-light'"
              @click="$router.push(data.path)"
              :disabled="(data.icon=='map' && isClosing==true) ? true : false"
              style="height:60px;"
            >
              <i class="ml-2 pl-1 align-middle me-4 bi" :class="`bi-${data.icon}`"></i>
              {{data.name}}
            </button>
          </div>

          <div class="mt-auto">
            <div class="m-3">
              <!-- Amplify v6対応カスタムサインアウトボタン -->
              <b-button variant="outline-danger" @click="handleSignOut" class="w-100 mb-3">
                サインアウト
              </b-button>
              <b-card class="align-items-center" no-body>
                <h6 class="mt-3">{{l_currentEnv}}</h6>
                <img src="./assets/logo/kaminoyama.jpg" class="img-fluid w-50">
              </b-card>
            </div>
            <div class="mb-3 ml-3 text-left">
              <b-button size="sm" @click="l_expandSideBar">
                <i class="bi bi-chevron-bar-left fs-3"></i>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <router-view v-slot="{ Component }">
        <transition>
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import store from './plugins/store/index.js'
import { Auth } from 'aws-amplify'
import util from '@/common/util.js'

export default {
  name: 'App',
  mixins: [util],
  data() {
    return {
      l_currentPath:"/",
      l_routerViewWidth:{"margin-left":"80px"},
      l_refleshtimer:"",
      l_sidebarAvailable:false,
      l_sidebarExpanding:false,
      l_sidebarMenuData:[
        {icon:"house", path:"/", name:"ホーム"},
        {icon:"columns-gap", path:"/dashboard", name:"ダッシュボード"},
        {icon:"map", path:"/routemanagement", name:"ルート管理"},
        {icon:"file-text", path:"/report", name:"レポート"},
        // {icon:"hdd-stack", path:"/datamanagement", name:"データ管理"},
        {icon:"person", path:"/mypage", name:"マイページ"},
      ],
      l_currentEnv:"N/A",
      l_currentRegion:"N/A",
      /*機能蓋閉じ用フラグ */
      isClosing: false

    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
    this.$store.watch(
      (state, getters) => getters.isSignIn,
      (newValue, oldValue) => {
        this.l_sidebarAvailable = newValue;
      }
    )
    var hostStrings = window.location.host;
    var envRegion = this.getCurrntEnvAndRegionFromURL(hostStrings)
    this.l_currentEnv = envRegion.env
    this.l_currentRegion = envRegion.region

    if (envRegion.env == "プレ運用環境" || envRegion.env == "正式運用環境") {
      this.isClosing = false
      this.l_sidebarMenuData = [
        { icon: "house", path: "/", name: "ホーム" },
        { icon: "columns-gap", path: "/dashboard", name: "ダッシュボード" },
        { icon: "map", path: "/routemanagement", name: "ルート管理" },
        { icon: "file-text", path: "/report", name: "レポート" },
        { icon: "person", path: "/mypage", name: "マイページ" },
      ]
    } else if (envRegion.env == "検証環境") {
      this.isClosing = false
      this.l_sidebarMenuData = [
        { icon: "house", path: "/", name: "ホーム" },
        { icon: "columns-gap", path: "/dashboard", name: "ダッシュボード" },
        { icon: "map", path: "/routemanagement", name: "ルート管理" },
        { icon: "file-text", path: "/report", name: "レポート" },
        { icon: "person", path: "/mypage", name: "マイページ" },
      ]
    } else {
      this.isClosing = false
    }
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
  },
  watch: {
    // Store Current Path
    $route (to, from){
      this.l_currentPath = to.path;
    },
    l_sidebarAvailable(newValue, oldValue){
      // Is User Sign in?
      if(newValue == true){
        // 以前の実装通り：サインイン時に初回APIデータを取得
        this.updateSequence();
        // 定期更新タイマーを開始
        this.l_refleshtimer = setInterval(this.updateSequence, 60000);
      }else{
        clearInterval(this.l_refleshtimer)
      }
    }
  },
  methods:{
    // Amplify v5.3.12サインアウト処理
    async handleSignOut() {
      try {
        await Auth.signOut()
        // Vuexストアから完全にユーザー情報をクリア
        this.$store.commit('setUser', null)
        this.$store.commit('setUserSignInStatus', false)
        // サイドバーを明示的に非表示にする
        this.l_sidebarAvailable = false
        this.$router.push('/signin')
      } catch (error) {
        console.error('Error signing out:', error)
      }
    },
    // Switch SideBar
    l_expandSideBar(){
      this.l_sidebarExpanding = !this.l_sidebarExpanding;
      this.l_sidebarExpanding == true ? (this.l_routerViewWidth["margin-left"]="280px") : (this.l_routerViewWidth["margin-left"]="80px")
    },
    updateSequence : async function(){
      await this.getVehicleDataWrapper()
      await this.getStationDataWrapper()
      await this.getTodayStationDataWrapper();
      await this.storeLogMessage();
      store.commit('setStationDataRefreshTime', moment().format('YYYY/MM/DD HH:mm:ss'))
    },
		// vehiclePositionRequest
		getVehicleDataWrapper : async function(){
			// ユーザーオブジェクトとトークンの存在確認
			const user = this.$store.getters.user;
			if (!user || !user.signInUserSession || !user.signInUserSession.idToken) {
				console.warn('User not properly authenticated, skipping API call');
				return;
			}

			const vreqdata = {
				headers: {
					"Authorization": user.signInUserSession.idToken.jwtToken
				},
				params:{
					vehicleFilter:0
				}
			};
			await axios.get(this.createAPI("dashboard/vehiclepositionrequest"),vreqdata)
			.then(response => {
				store.commit('setVehicleData', response.data)
			})
			.catch(error => {
				console.log("ERROR", error)
			})
		},
    getStationDataWrapper : async function(){
			// ユーザーオブジェクトとトークンの存在確認
			const user = this.$store.getters.user;
			if (!user || !user.signInUserSession || !user.signInUserSession.idToken) {
				console.warn('User not properly authenticated, skipping station data API call');
				return;
			}

			const streqdata = {
				headers: {
					"Authorization": user.signInUserSession.idToken.jwtToken
				},
				params:{
					stFilter:0,
					companyNumber:"",
          collectionArea:0
				}
			};
			await axios.get(this.createAPI("dashboard/garbagestationstatus"),streqdata)
			.then(response => {
				store.commit('setStationData', response.data)
        var list = {}
        for(var i in response.data.stStatus){
          list[response.data.stStatus[i].controlNumber] = {
            collectStatus:response.data.stStatus[i].collectStatus,
            garbageType:response.data.stStatus[i].garbageType,
            lastUpdated:response.data.stStatus[i]['last-update'],
            location:[response.data.stStatus[i].longitude, response.data.stStatus[i].latitude]
          }
        }
				store.commit('setStationDataIndex', list)
			})
			.catch(error => {
				console.log("ERROR", error)
			})
		},
		getTodayStationDataWrapper : async function(){
			// ユーザーオブジェクトとトークンの存在確認
			const user = this.$store.getters.user;
			if (!user || !user.signInUserSession || !user.signInUserSession.idToken) {
				console.warn('User not properly authenticated, skipping today station data API call');
				return;
			}

			const streqdata = {
				headers: {
					"Authorization": user.signInUserSession.idToken.jwtToken
				},
				params:{
					stFilter:1,
					companyNumber:"",
          collectionArea:0
				}
			};
      await axios.get(this.createAPI("dashboard/garbagestationstatus"), streqdata)
        .then(response => {
          var todaysList = {}
          var receiveddata = response.data.stStatus
          for (var i in receiveddata) {
            var statusData = { 'todayFlg': true, 'company': receiveddata[i].company, 'collectArea': receiveddata[i].collectArea, 'districtNo': receiveddata[i].districtNo }
            todaysList[receiveddata[i].controlNumber] = statusData
          }
          store.commit('setTodayStationData', todaysList)
          store.commit('setTodayStationDataLength', receiveddata.length)
			})
			.catch(error => {
				console.log("ERROR", error)
			})
		},
    storeLogMessage : async function(){
      let messageList = []
      const messageString = sessionStorage.getItem('logMessageList')
      if(messageString != null){
        messageList = messageString.split(",")

        // ユーザーオブジェクトとトークンの存在確認
        const user = this.$store.getters.user;
        if (!user || !user.signInUserSession || !user.signInUserSession.idToken) {
          console.warn('User not properly authenticated, skipping log message storage');
          return;
        }

        const hdrdata = {
          headers: {
            "Authorization": user.signInUserSession.idToken.jwtToken
          },
        };
        const paramdata = {
          messageList:messageList
        };
        axios.post(this.createAPI("common/webapplog"), paramdata, hdrdata)

        sessionStorage.removeItem('logMessageList')
      }
    },
    isLinkActive(path) {
      // ホーム画面は完全一致で判定
      if (path === '/') {
        return this.$route.path === '/';
      }
      // その他のリンクは前方一致で判定
      return this.$route.path.startsWith(path);
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap');

/* @import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p&display=swap'); */
#app {
  /* font-family: 'Noto Sans JP', 'Avenir', Helvetica, Arial, sans-serif; */
  /* font-family: 'M PLUS 1p', sans-serif; */
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge add Firefox */
.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}

/* 表示アニメーションをする前のスタイル */
.v-enter {
  opacity: 0;
}

/* 表示アニメーション後のスタイル */
.v-enter-to {
  opacity: 1;
}

/* 表示アニメーション動作中のスタイル */
.v-enter-active {
  transition: all 500ms;
}

.sidebar {
  transition: all 300ms;
}
:root {
  --amazonOrange: #1E7C3C;
  --darkAmazonOrange: #145328 ;
}
</style>
